import {AssertUtils} from "goingutils";
import GoToolTipCtl from "../../../jsCom/comCtl/goToolTipCtl";
/**
 * 获取当前输入框的宽度样式
 * @param width
 * @returns {*}
 */
export function getInputWid(width) {
    if (width === "big") {
        return "input-xlarge";
    } else if (width === "md") {
        return "input-medium";
    } else {
        return width;
    }
}

export function _getElStyle(item) {
    //如果传入的labelWidth大于0
    var width = item;
    if (typeof item == "object") {
        width = item.labelWidth;
    }
    if (parseFloat(width) > 0) {
        return `width:` + width + `px;min-width:` + width + `px;`;
    }
}

//获取星号的展示与隐藏
export function _getStartStyle({required}, {formType}) {
    if (formType === "editor" && required === true) {
        return ``;
    } else {
        return `style='display:none'`;
    }
}

//根据参数定义来设置input的值
export function _getInputElStyle({inputWidth}) {
    //如果传入的labelWidth大于0
    if (parseFloat(inputWidth) > 0) {
        return `width:${inputWidth}px`;
    }
    return "";
}

//根据参数定义来设置input的值
export function _getMaxLengthAttr(maxlength) {
    //如果传入的labelWidth大于0
    if (parseFloat(maxlength) > 0) {
        return `maxlength=${maxlength}`;
    }
    return "";
}

//获取disabled的属性
export function _getDisabledAttr(readOnly, disabled) {
    //如果传入的labelWidth大于0
    if (readOnly || disabled) {
        return `disabled=true`;
    }
    return "";
}

//获取disabled的class
export function _getDisabledClass(readOnly, disabled) {
    //如果传入的labelWidth大于0
    if (readOnly || disabled) {
        return ` input-disabled`;
    }
    return "";
}

//获取错误元素的样式
export function _getErrorElStyle(
    {labelWidth, inputWidth},
    width,
    top = 11,
    left = 0
) {
    if (AssertUtils.isNotEmpty(width)) {
        return `right:30px;top:6px`;
    }
    //如果传入的labelWidth大于0
    if (parseFloat(inputWidth) > 0) {
        return `left:${inputWidth - 20 + left}px;top:${top}px`;
    }
}

/**
 * 卸载相应的控件容器
 * @param inputId
 * @private
 */
export function _unloadAll(inputId) {
    //如果是treeDrop控件
    if ($(`#${inputId}_tree_drop`).get(0) != null) {
        $(`#${inputId}_tree_drop`)
            .parent()
            .parent()
            .remove();
    }
    //如果是静态下拉控件
    if ($(`#${inputId}_static_drop`).get(0) != null) {
        $(`#${inputId}_static_drop`)
            .parent()
            .parent()
            .remove();
    }
}

//清空输入的值
export function _clearInputVal(target, idsAry) {
    $(target).hide();
    idsAry.forEach(function (item) {
        if (AssertUtils.isNotEmpty(item)) {
            $("#" + item).val("");
        }
    });
}

//显示错误提醒信息
export function _showErrorToolTip(target, _itemId) {
    let clickEl = $(target).closest(".error-info");
    let msg = $(target).attr("msg");
    let toolTipCtl = new GoToolTipCtl({
        parent: $(clickEl),
        msg: msg,
        targetElId: _itemId
    });
}

//隐藏错误提醒信息
export function _hideErrorToolTip(target, _itemId) {
    $("#" + _itemId + "_toolTip").remove();
}

/**
 * 获取下拉控件的 下拉图标字符串
 * @param targetObj
 * @param id
 * @param iconClass
 * @returns {string}
 */
export function getDownIconStr(
    targetObj,
    id,
    iconClass = "ivu-icon ivu-icon-ios-arrow-down", inputId, dropType
) {
    return `<span inputId="${inputId}" dropType="${dropType}" id="${targetObj.prefixCls}_${id}_down" class="input-group-addon"><i class="${iconClass}"></i></span>`;
}

/**
 * 获取清空输入图标的样式信息
 * @returns {string}
 */
export function getClearIconStyle({inputWidth},rightPos=20) {
    if(parseFloat(inputWidth)>0){
        return `left:${parseFloat(inputWidth) - parseFloat(rightPos+"")}px;`;
    }

}

//显示校验错误信息
export function _showValidationError(inputId) {
    $(`#${inputId}`)
        .parent()
        .find(".error-info")
        .show();
    $(`#${inputId}`)
        .parent()
        .find(".clear-icon")
        .hide();
    $(`#${inputId}`).addClass("error-input");
}

/**
 * 清空图标的字符串构成
 * @param targetObj
 * @param id
 * @param treeRelId
 * @returns {string}
 */
export function goClearInputIcon(
    targetObj,
    id,
    treeRelId = "",
    rightPos=20
) {
    return `
   <div id="${targetObj.prefixCls}_${id}_clear"   onclick="_clearInputVal(this,['${targetObj.prefixCls}_${id}','${treeRelId}'])" class="close-icon-div" style="${getClearIconStyle(targetObj,rightPos)};display: none;">
    <i class="ivu-icon ivu-icon-ios-close-circle"></i>
  </div>
`;
}

/**
 * 数字段 时间段查询的清空图标字符串构成
 * @param targetObj
 * @param id
 * @param treeRelId
 * @returns {string}
 */
export function goRangeClearInputIcon(
    targetObj,
    id,
    inputSuffix,
    right = 5
) {
    let inputVal = $(
        "#" + targetObj.prefixCls + "_" + id + "_" + inputSuffix
    ).val();
    return `
   <div onclick="_clearInputVal(this,['${
        targetObj.prefixCls
        }_${id}_${inputSuffix}'])" class="close-icon-div" style="${getRangeClearIconStyle(
        right,
        inputVal
    )}">
    <i   class="ivu-icon ivu-icon-ios-close-circle"></i>
  </div>`;
}

/**
 * 获取清空输入图标的样式信息
 * @returns {string}
 */
export function getRangeClearIconStyle(right = 20, inputVal = "") {
    let style = "";
    if ((inputVal + "").length > 0) {
        style = "display:block;";
    } else {
        style = "display:none";
    }
    return `right:${right}px;top:-3px;font-size:16px;cursor:pointer;position:absolute;${style}`;
}

/**
 * 长度最大值输入提醒
 * @param targetObj
 * @param value
 * @param maxLength
 * @returns {string}
 */
export function goMaxLengthLabel(
    targetObj,
    id,
    value,
    maxLength,
    inputWidth
) {
    return `
  <div class="go-maxlength-label" style="left:${parseFloat(inputWidth) - 36}px">
     <span id="${targetObj.prefixCls}_${id}_count">${(value + "").length}/${maxLength}</span>
  </div>
  `;
}

export function _getErrorIconStyle({inputWidth}) {
    return `top:0;left:${parseFloat(inputWidth) - 20}px`;
}

/**
 * 错误提醒图标的字符串
 * @param targetObj
 * @param id
 * @param treeRelId
 * @returns {string}
 */
export function goErrorInputIcon(targetObj, id) {
    return `<div class="error-icon-div error-info" onmouseover="_showErrorToolTip(this,'${id}')" onmouseleave="_hideErrorToolTip(this,'${id}')" style="${_getErrorIconStyle(targetObj )}">
    <!--必填校验-->
    <i  class="ivu-icon ivu-icon-md-warning"></i>
  </div>
`;
}

//初始化下拉控件的html代码
export function _dropSingleCommonHtml(
    {treeRelId, required, label, id},
    targetObj,
    ctlClassName,
    iconClass
) {
    let relHtml = "";
    if (AssertUtils.isNotNull(treeRelId)) {
        relHtml = `  <input type="hidden"    id="${
            targetObj.prefixCls
            }_${treeRelId}" class="go-ctl-tree-relinput form-control"> `;
    } else {
        relHtml = `  <input type="hidden"  id="${
            targetObj.prefixCls
            }_${id}_val" class="go-ctl-tree-relinput form-control"> `;
    }
    return ` <div class="go-content" style="position: relative;padding-left: 8px;">
                <div class="input-group"  style="cursor: pointer;${_getInputElStyle(
        targetObj
    )};position: relative;">
                ${relHtml}
                <input type="text"  style="height:25px;border: none;" readonly=true  ctl="auto"  treeRelId="${treeRelId}" id="${
        targetObj.prefixCls
        }_${id}" placeholder="请选择数据" class="${ctlClassName} form-control">
                ${goClearInputIcon(targetObj, id, treeRelId, 40)}
                ${goErrorInputIcon(targetObj, id, treeRelId)}
                ${getDownIconStr(targetObj, id, iconClass)}
                </div>
            </div>`;
}

//获取输入框是否只读的标识
export function getReadOnly(readonly) {
    if (readonly === true) {
        return " readonly=true ";
    } else {
        return "";
    }
}

//初始化下拉控件的html代码
export function _dropCommonHtml(
    {
        treeRelId,
        required,
        label,
        id,
        defVal = "",
        readonly = true,
        treeRelVal = "",
        labelWidth = "md",
        inputWidth = "auto"
    },
    targetObj,
    ctlClassName,
    iconClass
) {
    let relHtml = "";
    if (AssertUtils.isNotNull(treeRelId)) {
        relHtml = `  <input type="hidden" value="${treeRelVal}"  id="${
            targetObj.prefixCls
            }_${treeRelId}" class="go-ctl-tree-relinput form-control"> `;
    } else {
        relHtml = `  <input type="hidden"  value="${defVal}"   id="${
            targetObj.prefixCls
            }_${id}_val" class="go-ctl-tree-relinput form-control"> `;
    }

    return `<div class="row go-form-row flex-div go-top-page go-common-drop-ctl">
                <div class="go-label" style="${_getElStyle(targetObj)}"><span ${_getStartStyle({required}, targetObj)} class="start-require">*</span> ${label}：</div>
                <div class="go-content ${getInputWid(inputWidth)}">
                    <div class="input-group"  style="cursor: pointer;${_getInputElStyle(targetObj)}">
                    ${relHtml}
                    <input type="text"  ${getReadOnly(readonly)}  ctl="auto" value="${defVal}"
                      treeRelId="${treeRelId}" id="${targetObj.prefixCls}_${id}" placeholder="请选择数据" class="${ctlClassName} form-control">
                    ${goClearInputIcon(targetObj, id, treeRelId, 38)}
                    ${goErrorInputIcon(targetObj, id, treeRelId)}
                    ${getDownIconStr(targetObj, id, iconClass)}
                    </div>
                </div>
            </div>`;
}

//下拉的时候 根据value获取对应的label
export function _getLabelByValue(propValue, items) {
    let commonJson = {};
    items.forEach(function (item) {
        (commonJson)[item["id"] || item["value"]] = item["label"];
    });
    return (commonJson)[propValue];
}

/**
 * 隐藏清空输入的图标
 * @param inputId
 * @private
 */
export function _hideClearIcon(inputId) {
    $(`#${inputId}_clear`).hide();
}

/**
 * 显示清空内容的图标
 * @param inputId
 * @param parentObj
 * @private
 */
export function _showClearIcon(inputId,parentObj) {
    $(parentObj).find(".close-icon-div").hide();
    $(`#${inputId}_clear`).show();
    $(`#${inputId}_clear`).unbind().bind('mouseover',function () {
        $(this).show();
    }).bind('mouseleave',function () {
        $(this).hide();
    });
}


//清楚校验效果
export function _removeValidationInfo(inputId) {
    $(`#${inputId}`).removeClass("error-input");
    $(`#${inputId}`)
        .parent()
        .find(".error-info")
        .hide();
}



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/Common_Fun.js